<template>
  <el-select
    v-model="selected"
    v-select-load="selectLoad"
    :disabled="disabled"
    :multiple="multiple"
    reserve-keyword
    :loading="loading"
    :placeholder="placeholder"
    :size="size"
    :collapse-tags="collapseTags"
    clearable
    filterable
    :filter-method="filterMethod"
    @change="getSelected"
    @clear="handleClear"
    @visible-change="visibleChange"
    ref="select"
    :popper-class="`sino_select_popover ${popperClass}`"
  >
    <!-- @remove-tag="removeTag" -->
    <el-option
      v-for="item in options"
      :key="item[optionVal]"
      :label="item[optionLab]"
      :value="item[optionVal]"
    >
      <slot
        name="option"
        :row="item"
      >
        <span v-if="isUserAccount">{{
          (item.name || "--") + "（" + item.account + "）"
        }}</span>
        <span v-else>{{ item[optionLab] }}</span>
      </slot>
    </el-option>
    <p
      v-if="textLoading && !isLast"
      class="el-loading-text"
    >
      <i class="el-icon-loading" />数据加载中
    </p>
  </el-select>
</template>

<script>
import utils from "../../scripts/utils";
import request from "../../scripts/request";
import selectLoad from "../../scripts/selectLoad";
export default {
  name: "sinoSelect",
  mixins: [selectLoad],
  props: {
    value: {
      type: [String, Number, Array],
      default() {
        return [];
      },
    },
    api: {
      // 请求下拉列表接口路径
      type: String,
      required: true,
    },
    optionApi: {
      // 请求回显数据接口
      type: String,
      default: "",
    },
    optionMethod: {
      // 请求回显数据接口方式
      type: String,
      default: "post",
    },
    optionNoquery: {
      //请求回显数据接口是否需要传参
      type: Boolean,
      default: false,
    },
    requestMethod: {
      // 接口请求方式（post/get）
      type: String,
      default: "get",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      // 选择框尺寸
      type: String,
      default: "",
    },
    selectOption: {
      //已选数据
      type: [Object, Array],
      default() {
        return null;
      },
    },
    optionLab: {
      // 下拉框展示文本label
      type: String,
      default: "name",
    },
    optionVal: {
      // 下拉框绑定数据value
      type: String,
      default: "uuid",
    },
    queryKeys: {
      // 除开分页及输入框对应值查询其他条件
      type: Object,
      default() {
        return {};
      },
    },
    reload: {
      // 该参数传入true时重新加载数据
      type: Boolean,
      default: false,
    },
    collapseTags: {
      //多选时是否将选中值按文字的形式展示
      type: Boolean,
      default: false,
    },
    isInit: {
      // 是否默认请求列表接口
      type: Boolean,
      default: true,
    },
    queryLab: {
      // 查询字段与展示label不一致时传入，根据该字段输入查询
      type: String,
      default: "",
    },
    filterObj: {
      // 筛选条件，用于后端不支持筛选时
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    isUserAccount: {
      //选项是否显示用户账号
      type: Boolean,
      default: false,
    },
    pageQuery: {
      //分页
      type: Object,
      default: () => {
        return {
          pageSize: 50,
          pageNum: 1,
        };
      },
    },
    popperClass: {
      //Select 下拉框的类名
      type: String,
      default: "",
    },
    uniqueKey: {
      type: String,
      default: "uuid",
    },
  },
  data() {
    return {
      selected: this.value,
      options: [],
      selectOptions: [],
      loading: false, // 下拉框loading
      textLoading: false, // 触底加载文字loading
      isLast: false, // 是否最后一页数据
      query: "", // 输入框输入值
      // pageQuery: {
      //   pageSize: 50,
      //   pageNum: 1,
      // },
    };
  },
  watch: {
    value(val) {
      this.selected = val;
      if (this.selectOptions.length == 0) {
        this.getOptions();
      }
    },
    reload(val) {
      // 重新请求数据，防止新增数据未展示
      if (val) {
        this.pageQuery.pageNum = 1;
        this.selectOptions = [];
        this.getOptions();
        this.getSelectList();
      }
    },
    queryKeys: {
      deep: true,
      handler() {
        this.pageQuery.pageNum = 1;
        this.selectOptions = [];
        this.getSelectList();
      },
    },
  },
  created() {
    if (this.isInit) {
      this.getOptions();
      this.getSelectList();
    }
  },
  methods: {
    /**清除下拉框数据 */
    clearOptions() {
      this.options = [];
      this.selectOptions = [];
    },
    handleClear() {
      this.$emit("clear");
      this.getSelectList();
    },
    // 获取选中数据传出组件
    getSelected(val) {
      let selected = null;
      if (this.multiple) {
        selected = this.options.filter((item) =>
          val.includes(item[this.optionVal])
        );

        if (val.length > this.selectOptions.length) {
          this.selectOptions = utils.unique(
            selected.concat(this.selectOptions),
           this.uniqueKey
          );
        } else {
          this.selectOptions = this.selectOptions.filter((el) =>
            val.includes(el[this.optionVal])
          );
        }
      } else {
        selected =
          this.options.find((item) => item[this.optionVal] === val) || null;
        if (selected) {
          this.selectOptions = utils.unique(
            [selected].concat(this.selectOptions),
            this.uniqueKey
          );
        }
      }
      this.$emit("input", val);
      if (this.multiple) {
        let selectValues = val.length > 0 ? this.selectOptions : [];
        this.$emit("select", selectValues);
      } else {
        this.$emit("select", selected);
      }
    },
    // 触底加载事件
    selectLoad() {
      if (!this.isLast && !this.loading && !this.textLoading) {
        this.pageQuery.pageNum++;
        this.textLoading = true;
        setTimeout(() => {
          this.getSelectList(true);
        }, 500);
      }
    },
    // 根据选中值获取下拉框回显数据
    getOptions() {
      if (this.value && this.value.length > 0) {
        if (this.optionApi) {
          let uuids = this.multiple ? this.value : [this.value];
          let paramQuery = {};
          if (this.optionNoquery) {
            paramQuery = {};
          } else {
            if (this.optionMethod == "get") {
              paramQuery = { params: uuids };
            } else if (this.optionMethod == "post") {
              paramQuery = { data: uuids };
            }
          }
          request({
            url: this.optionApi,
            method: this.optionMethod,
            ...paramQuery,
          }).then((res) => {
            if (res.code === "00000" && res.data) {
              let data = res.data;
              if (data instanceof Array) {
                this.selectOptions = data;
              } else {
                this.selectOptions = [data];
              }
              this.options = utils.unique(
                this.selectOptions.concat(this.options),
                this.uniqueKey
              );
            }
          });
        } else {
          if (this.selectOption) {
            let selectOption=this.selectOptions.concat(this.selectOption);
            this.options = utils.unique(
              selectOption.concat(this.options),
              this.uniqueKey
            );
          }
        }
      }
    },
    // 获取下拉列表数据
    /**
     * @param isAdd 是否融合数据，是否将新请求数据与原有数据合并，true:合并
     * @param query 是否查询
     */
    getSelectList(isAdd, query = false) {
      if (!isAdd) {
        this.loading = true;
      }
      let key = this.queryLab || this.optionLab;
      let queryKey = JSON.parse(JSON.stringify(this.queryKeys)) || {};
      let queryParams = Object.assign(queryKey, this.pageQuery);
      queryParams[key] = this.query;
      let data = {
        url: this.api,
        method: this.requestMethod,
      };

      if (this.requestMethod === "get") {
        data.params = queryParams;
      } else {
        data.data = queryParams;
      }
      request(data)
        .then((res) => {
          if (res.code === "00000") {
            let data =
              res.data && res.data.records
                ? res.data.records
                : res.data
                ? res.data
                : [];
            let selectOptions = this.selectOptions || [];
            if (query) {
              selectOptions = [];
            }
            if (isAdd) {
              this.options = utils.unique(
                selectOptions.concat(this.options.concat(data)),
                this.uniqueKey
              );
            } else {
              this.options = utils.unique(
                selectOptions.concat([...data]),
                this.uniqueKey
              );
            }
            if (this.pageQuery.pageSize == -1) {
              this.isLast = true;
            } else {
              let pages = 1;
              if (res.data) {
                if (res.data.pages) {
                  pages = res.data.pages;
                } else if (res.data.total) {
                  let total = Number(res.data.total);
                  let pageNum = Number(this.pageQuery.pageNum);
                  pages = Math.ceil(total / pageNum);
                }
              }
              if (data.length === 0) {
                this.isLast = data.length === 0;
              } else {
                this.isLast = pages <= this.pageQuery.pageNum;
              }
            }
          }
          this.filterOptions();
          if (!isAdd) {
            this.loading = false;
          } else {
            this.textLoading = false;
          }
        })
        .catch(() => {
          if (!isAdd) {
            this.loading = false;
          } else {
            this.textLoading = false;
          }
        });
    },
    // 自定义输入筛选事件
    filterMethod(query) {
      this.query = query;
      this.pageQuery.pageNum = 1;
      this.getSelectList(false, true);
    },
    /**下拉框显示隐藏时间 */
    visibleChange(val) {
      if (!val) {
        this.query = "";
        this.pageQuery.pageNum = 1;
        this.getSelectList();
      }
    },
    // 自定义筛选下拉数据方法
    filterOptions() {
      const filter = this.filterObj;
      if (!filter || this.options.length === 0) return;
      this.options = this.options.filter(
        (item) => item[filter.key] === filter.val
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-loading-text {
  color: $primaryColor;
  text-align: center;

  .el-icon-loading {
    margin-right: 5px;
  }
}
</style>
<style lang="scss">
.sino_select_popover {
}
</style>
